import script from "./autocomplete-result-item.vue?vue&type=script&lang=ts&setup=true"
export * from "./autocomplete-result-item.vue?vue&type=script&lang=ts&setup=true"

import "./autocomplete-result-item.vue?vue&type=style&index=0&id=c57b1bf4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c57b1bf4"]])

export default __exports__